import { render, staticRenderFns } from "./TeacherDocumentListDialog.vue?vue&type=template&id=49e3cb51&"
import script from "./TeacherDocumentListDialog.vue?vue&type=script&lang=ts&"
export * from "./TeacherDocumentListDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports